<template>
    <tr>
        <td>
            <span v-if="translated_name">{{translated_name}}</span><span v-else>{{name}}</span>
        </td>
        <td>
          {{type}}
        </td>
        <td>
            {{version}}
        </td>
        <td class="text-center">
            <span v-if="needs_update === 1">
                {{next_version}}
            </span>
            <span v-else>
              <span>-</span>
            </span>
        </td>
        <td class="text-center">
            <div class="extension-action" v-bind:class="stateClass">
              <div v-if="!supportsUpdate">
                <div>
                  <span class="visuallyhidden">
                    {{$t('site.doesnotsupportupdate')}}
                  </span>
                  <img v-b-tooltip.top="$t('site.doesnotsupportupdate')" src="/images/icon/siteinformation/icon_warning.svg"/>
                </div>
              </div>
              <div v-else>
                <div v-if="needs_update === 1">
                  <span v-if="ignore_update === 0">
                    <span v-if="process_state === 8">
                      <button class="btn btn--failed--link" v-on:click="localUpdateExtension()">
                        {{$t('site.extensionupdatefaileddoitagain')}}
                      </button>
                    </span>

                    <span v-if="process_state === 0">
                      <button class="btn btn--success" v-on:click="localUpdateExtension()">
                        {{$t('site.update')}}
                      </button>
                    </span>

                    <span v-if="(process_state === 0 || process_state === 8) && errorDetails">
                      <img v-b-tooltip.top="errorDetails" class="mx-2" src="/images/icon/siteinformation/icon_warning.svg"/>
                    </span>

                    <span v-if="process_state === 1">
                      <font-awesome-icon :icon="['fal','spinner']" pulse></font-awesome-icon>
                    </span>

                    <span v-if="process_state === 2">
                      <font-awesome-icon :icon="['fal','check-circle']" class="text--success"></font-awesome-icon>
                    </span>
                  </span>
                  <span v-if="process_state !== 1">
                    <span v-if="ignore_update === 0">
                      <button v-b-tooltip.top="'Ignore Extension Updates'" class="btn btn--failed--link" v-on:click="localIgnoreUpdateExtension()">
                        <img src="/images/icon/siteinformation/icon_ignore.svg"/>
                      </button>
                    </span>
                    <span v-if="ignore_update === 1">
                      <button v-b-tooltip.top="'Ignore Extension Updates'" class="btn btn--failed--link" v-on:click="localIgnoreUpdateExtension()">
                        <img src="/images/icon/siteinformation/icon_ignore.svg"/>
                      </button>
                    </span>
                  </span>
                </div>
                <div v-else>
                  <span>
                    <font-awesome-icon :icon="['fal','check-circle']" class="text--success"></font-awesome-icon>
                  </span>
                  <span v-if="process_state !== 1">
                    <span v-if="ignore_update === 0">
                      <button v-b-tooltip.top="'Ignore Extension Updates'" class="btn btn--failed--link" v-on:click="localIgnoreUpdateExtension()">
                        <img src="/images/icon/siteinformation/icon_ignore.svg"/>
                      </button>
                    </span>
                    <span v-if="ignore_update === 1">
                      <button v-b-tooltip.top="'Ignore Extension Updates'" class="btn btn--failed--link" v-on:click="localIgnoreUpdateExtension()">
                        <img src="/images/icon/siteinformation/icon_ignore.svg"/>
                      </button>
                    </span>
                  </span>
                </div>
              </div>
            </div>
        </td>
        <td class="text-center">
          <b-form-select
            v-if="supportsUpdate"
            v-model="selected"
            :class="enabled ? 'auto-on' : 'auto-off'"
            :options="options"
            v-on:change="localAutoupdateChange"
          ></b-form-select>
        </td>
    </tr>

</template>

<script>

import { mapActions } from 'vuex'

export default {

  name: 'SiteDetailExtensionItem',

  props: {
    id: Number,
    name: String,
    type: String,
    version: String,
    next_version: String,
    rowType: String,
    rowOdd: String,
    process_state: Number,
    needs_update: Number,
    translated_name: String,
    ignore_update: Number,
    autoupdate_enabled: Number,
    global_autoupdate_enabled: Number,
    support_update: Boolean,
    last_update_messages: Array
  },

  computed: {
    stateClass () {
      return 'state-' + this.process_state
    },

    enabled () {
      return this.autoupdate_enabled === 1 || (this.autoupdate_enabled === -1 && this.global_autoupdate_enabled === 1)
    },

    selected: {
      get () {
        return this.autoupdate_enabled
      },

      set (value) {
        this.autoupdate_enabled = value
      }
    },

    supportsUpdate () {
      return this.support_update === true
    },

    errorDetails () {
      if (!this.last_update_messages || !this.last_update_messages.length) {
        return false
      }

      return this.last_update_messages.join('; ')
    }
  },

  data () {
    return {
      options: [
        { value: -1, text: this.global_autoupdate_enabled === 1 ? this.$t('config.globalautoupdateon') : this.$t('config.globalautoupdateoff') },
        { value: 0, text: this.$t('config.autoupdateoff') },
        { value: 1, text: this.$t('config.autoupdateon') }
      ]
    }
  },

  methods: {
    ...mapActions('site', [
      'toggleExtensionIgnoreState',
      'updateExtension',
      'autoUpdateChangeById'
    ]),

    localUpdateExtension () {
      if (this.process_state === 0 || this.process_state === 8) {
        this.updateExtension(this.id)
      }
    },

    localIgnoreUpdateExtension () {
      this.toggleExtensionIgnoreState(this.id)
    },

    localAutoupdateChange () {
      const payload = {
        id: this.id,
        autoupdate: this.selected
      }
      this.autoUpdateChangeById(payload)
    }
  }
}
</script>
